module.exports = __webpack_public_path__ + "media/assets/images/blog/pexels-christina-morillo-1181304-small-85ce21c3bf1c7db5083653f61d8d5e82.jpg";